import { Component, OnInit } from '@angular/core';
import { ConexionesService } from '../../services/conexiones.service'

import { environment } from "../../../environments/environment";



@Component({
  selector: 'app-apoyos',
  templateUrl: './apoyos.component.html',
  styleUrls: ['./apoyos.component.css']
})
export class ApoyosComponent implements OnInit {
  folio: any;
  estado: any
  bandera = false;
  tipo: any;
  nombre: any;
  apaterno: any;
  amaterno: any;
  porFolio = false;
  folio2: any;
  norobot = false;
  siteKey = environment.KEY_CAPTCHA;
  lang = "es";
  captcha = false;
  escuela: any;
  constructor(private db: ConexionesService) { }

  ngOnInit(): void {
    this.folio = "";
    this.nombre = "";
    this.apaterno = "";
    this.amaterno = "";
    this.tipo = "1";
  }


  opcionSelect() {
    this.bandera = false;
    this.folio = "";
    this.nombre = "";
    this.apaterno = "";
    this.amaterno = "";
    this.escuela = "";

    if (this.tipo == "1") {
      this.porFolio = true;
    }
    if (this.tipo == "2") {
      this.porFolio = false;
    }
  }
  onKeydownEvent() {

    this.bandera = false;
  }
  enviarFolio() {

    this.bandera = true;

    if (this.tipo == "2") {
      this.folio = "";
    }

    this.db.getFolioApoyo(this.folio, this.nombre, this.apaterno, this.amaterno).then((data: any) => {
      this.bandera = true;

      console.log(data)
      if (data.length >= 1) {
        this.escuela = "";
       
        if(data[0].autorizado==1){
          this.estado = "AUTORIZADO";
          this.folio2 = data[0].folio;
        }else{
          this.estado = "NO AUTORIZADO";
          this.escuela = data[0].comentarios;
        }
        //   this.escuela = data[0].escuela;
      } else {
        this.estado = "VERIFICAR NUMERO DE FOLIO";
        this.escuela = "";
      }

      //  this.estado= data[0].estado;

    })
  }
  handleSuccess(e) {
    this.captcha = true;
    this.norobot = true;

  }

  handleExpire(e) {
    this.captcha = false;
  }
}
